import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useContext, useState } from "react";
var GlobalDocModalContext = /*#__PURE__*/ createContext(undefined);
export var GlobalDocModalProvider = function(param) {
    var children = param.children;
    var _useState = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 438,
        height: 330,
        pin: false,
        mode: "normal",
        modalname: "noti-doc-number",
        extra: {
            genDocNumber: "-",
            createdDocNumber: "-"
        }
    }), 2), modalNotiDocAlert = _useState[0], setModalNotiDocAlert = _useState[1];
    var contextValue = {
        modalNotiDocAlert: modalNotiDocAlert,
        setModalNotiDocAlert: setModalNotiDocAlert
    };
    return /*#__PURE__*/ _jsx(GlobalDocModalContext.Provider, {
        value: contextValue,
        children: children
    });
};
export var useGlobalDocModalContext = function() {
    var context = useContext(GlobalDocModalContext);
    if (!context) {
        throw new Error("useGlobalDocModalContext must be used within a GlobalDocModalProvider");
    }
    return context;
};
